(() => {
  const enhance = (scope) => {
    scope.querySelectorAll('.bbe-tab-section').forEach((section) => {
      if (section.dataset.bbeReady) return;
      const controls = section.querySelector('.bbe-tab-controls');
      const buttons = [...section.querySelectorAll('[data-bbe-tab]')];
      const panels = [...section.querySelectorAll('[data-bbe-panel]')];
      if (!controls || !buttons.length || panels.length !== buttons.length) return;
      const show = (key) => {
        buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.bbeTab === key)));
        panels.forEach((panel) => { panel.hidden = panel.dataset.bbePanel !== key; });
      };
      buttons.forEach((button) => button.addEventListener('click', () => show(button.dataset.bbeTab)));
      controls.hidden = false;
      section.dataset.bbeReady = 'true';
      show(buttons[0].dataset.bbeTab);
    });
  };
  enhance(document);
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
